import React from 'react';
import { motion } from 'framer-motion';
import { Clock, CheckCircle2 } from 'lucide-react';
const requests = [{
  id: 1,
  title: 'Private Jet Charter',
  details: 'GVA to LCY • Tomorrow, 09:00',
  status: 'pending',
  icon: Clock
}, {
  id: 2,
  title: 'Nobu Milano',
  details: 'Table for 2 • Friday, 20:30',
  status: 'confirmed',
  icon: CheckCircle2
}];
export function ActiveRequests() {
  return <section className="px-6 py-4 mb-24" data-id="element-10">
      <h2 className="text-xl text-white font-light tracking-wide mb-4" data-id="element-11">
        Active Requests
      </h2>
      <div className="space-y-3" data-id="element-12">
        {requests.map((req, idx) => {
        const Icon = req.icon;
        const isConfirmed = req.status === 'confirmed';
        return <motion.div key={req.id} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5 + idx * 0.1,
          duration: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} whileHover={{
          scale: 1.01
        }} className="glass-card rounded-2xl p-4 flex items-center justify-between group cursor-pointer" data-id="element-13">
              <div className="flex items-center gap-4" data-id="element-14">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isConfirmed ? 'bg-sea-teal/20 text-sea-light' : 'bg-desert-dusk/20 text-desert-dusk'}`} data-id="element-15">
                  <Icon className="w-5 h-5" strokeWidth={1.5} data-id="element-16" />
                </div>
                <div data-id="element-17">
                  <h4 className="text-white font-medium text-sm mb-0.5" data-id="element-18">
                    {req.title}
                  </h4>
                  <p className="text-xs text-titanium-300" data-id="element-19">{req.details}</p>
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-20">
                <span className="text-xs font-medium uppercase tracking-wider text-titanium-400" data-id="element-21">
                  {req.status}
                </span>
                <div className={`w-1.5 h-1.5 rounded-full ${isConfirmed ? 'bg-sea-light shadow-[0_0_8px_rgba(42,124,126,0.8)]' : 'bg-desert-dusk shadow-[0_0_8px_rgba(196,149,106,0.8)]'}`} data-id="element-22" />
              </div>
            </motion.div>;
      })}
      </div>
    </section>;
}